export interface IGroupParticipant {
  groupId: string;
  splitUserId: string;
  name: string;
  validated: boolean;
  modakUserId?: string;
  balance: number;
}

export enum EGroupMemberStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export enum ESplitBillBalanceMode {
  OWED = 'owed',
  OWE = 'owe',
}

export interface ISplitBillGroupMember {
  id: string;
  name: string;
  status: EGroupMemberStatus;
  isOwner: boolean;
  isCurrentUser: boolean;
}

export interface IBalanceMember {
  id: string;
  name: string;
}

export interface ISplitBillGroupBalanceItem {
  amount: number;
  members: IBalanceMember[];
}

export interface ISplitBillGroupBalances {
  youOwe: ISplitBillGroupBalanceItem;
  youAreOwed: ISplitBillGroupBalanceItem;
}

export interface ISplitBillGroupDetails {
  members: ISplitBillGroupMember[];
  balances: ISplitBillGroupBalances;
}

export interface ISplitBillGroupSettlement {
  groupId: string;
  fromSplitUserId: string;
  toSplitUserId: string;
  amount: number;
}

export interface IBalanceItemMemberUI {
  id: string;
  name: string;
  amount: number;
  modakUserId?: string;
}

export interface IBalanceItemUI {
  amount: number;
  members: IBalanceItemMemberUI[];
}

export interface IBalancesUI {
  owed: IBalanceItemUI;
  owe: IBalanceItemUI;
}

export interface IGroupMember {
  id: string;
  name: string;
  description?: string;
  isYou: boolean;
  isOwner: boolean;
}

export interface ISettlementMember {
  from: string;
  to: string;
  amount: number;
  settled_by: string;
}
